import { render } from "./ModulTypeDetailVx.vue?vue&type=template&id=5f1170f2&scoped=true"
import script from "./ModulTypeDetailVx.vue?vue&type=script&lang=js"
export * from "./ModulTypeDetailVx.vue?vue&type=script&lang=js"

import "./ModulTypeDetailVx.vue?vue&type=style&index=0&id=5f1170f2&lang=css"
import "./ModulTypeDetailVx.vue?vue&type=style&index=1&id=5f1170f2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1170f2"]])

export default __exports__